<template>
	<div class="passSet componetself" v-loading="PLOAD">
		<div class="componet_header">
			<div class="filter">
				<template v-for="(item,index) in  passList">
					<div class="filter_item" :key="index">
						<c-filter :item="item" :form="dform" :line="true" :textMini="90" :IsForm="true"
							@blur="checkPassCase">
							<template v-slot:right="data">
								<template v-if="data.customerData.name=='repass'&&PASSCASE.QD">
									<vaildPass ref="PassCaseCheck" :PASSCASE="PASSCASE"
										:pass="dform[data.customerData.name]||''" :old="dform['old']"></vaildPass>
								</template>
							</template>

						</c-filter>
						<template v-if="item.name=='repass'">
							<div class="passLine">
								<div class="passLinetext" v-html="PassDisplay">
								</div>
							</div>
						</template>
					</div>
				</template>
			</div>
		</div>

		<div class="componet_header">
			<el-button type="primary" class="pursh_mainBtn" :loading="saveLoad" :disabled="saveLoad" @click="SAVEREQ">修改密码</el-button>
		</div>
	</div>
</template>

<script>
	import vaildPass from '../vaildPass.vue';
	import {pass} from './filesetItem.js'
	export default {
		data() {
			return {
				dform: {},
				saveLoad: false,
				PASSCASE: {},
				PLOAD: false,
				PassDisplay: '',
			}

		},
		computed: {
			userinfo() {
				return this.$store.getters.UserInfo;
			},
			passList(){
				return pass;
			}
		},
		components:{vaildPass},
		methods: {
			SAVEREQ(){
				try{
					if(this.saveLoad) return;
					this.saveLoad = true;
					for(let i in this.passList){
						let name=this.passList[i]['name'];
						if(this.dform[name]=='')
							throw `${this.passList[i]['Display']}不得为空`;
					}
						
					if(this.dform.recheckpass!=this.dform.repass) throw '两次输入新密码不一致';
					if(this.dform.recheckpass==this.dform.old) throw '新密码和旧密码不能相同';
					console.log(this.$refs.PassCaseCheck)
					if(this.$refs.PassCaseCheck&&this.$refs.PassCaseCheck[0]&&!this.$refs.PassCaseCheck[0].changeColor(this.dform['repass']))
						throw '密码校验不通过，请按照规则输入新密码';
					this.$BH().base.http({ //获取默认的账号
						url: 'Web/UpdateGYSPass',
						data: {
							user: this.userinfo.pfnumber,
							newPass: this.dform.recheckpass,
							oldPass:this.dform.old,
							gysuser:this.userinfo.fnumber,
							usertype:this.userinfo.accountType
						},
						success: (res) => {
							this.$BH().message(res.data.value);
							this.$store.commit('appendUserInfo', {"rePass":false});
							this.$store.commit('appendUserInfo', {"rePassCase":false});
							setTimeout(()=>{
								this.$emit('close')
							},100);
						},
						loadingcontrol: () => {
							this.saveLoad = false;
						}
					});
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
					this.saveLoad=false;
				}
			},
			checkPassCase(subItem){
				// console.log(this.$refs.PassCaseCheck)
				if(subItem.name=='repass'
				&&this.dform['repass']&&this.$refs.PassCaseCheck&&this.$refs.PassCaseCheck.changeColor){
					let res=this.$refs.PassCaseCheck.changeColor(this.dform['repass']);
					if(!res){
						this.$BH().message('密码校验不通过,需要满足相应规则');
					}
				}
			},
			getPsC() {
				try {
					console.log(this.userinfo)
					this.PLOAD = true;
					this.$BH().base.http({ //获取默认的账号
						url: 'Web/GetGYSPASSCASE',
						data: {
							user: this.userinfo.fnumber,
							usertype:this.userinfo.accountType,
							gysnumber:this.userinfo.fnumber
						},
						success: (res) => {
							this.PASSCASE = res.data.value;
							if (this.PASSCASE.Rule && this.PASSCASE.Rule[0] && this.PASSCASE.Rule[0]
								.FDisplay) {
								let str = this.PASSCASE.Rule[0].FDisplay;
								this.PassDisplay = str.replace(/\\n/g, '<br/>·');
							}
							this.passList.map(item=>{
								this.dform[item['name']]='';
							});
							this.dform=JSON.parse(JSON.stringify(this.dform))
						},
						loadingcontrol: () => {
							this.PLOAD = false;
						}
					});
				} catch (e) {
					//TODO handle the exception
					this.PLOAD = false;
					this.$BH().message(e);
				}
			},
		},
		created() {
			this.getPsC()
		}
	}
</script>

<style>
</style>
